import PageContent from '../../components/PageContent';
import { Form, Input, Button, message, Spin } from 'antd';
import { addTeam } from '../../api/Team';
import { getPersonalInfo } from '../../api/User';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../../features/user/userSlice';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const AddTeam = () => {
  // 引入多语言Hooks
  const { t } = useTranslation();
  // 定义变量
  const [loading, setLoading] = useState(false);
  // 表单对象
  const [form] = Form.useForm();
  // redux dispatch
  const dispatch = useDispatch();
  // 跳转函数
  const navigate = useNavigate();

  // 更新用户团队信息
  const _UPLOADTEAMID = async () => {
    try {
      const { code, data } = await getPersonalInfo();
      if (code === '10000') {
        const user = JSON.parse(localStorage.getItem('user'));
        user.user.team_id = data.team_id;
        dispatch(setUser(user));
      }
    } catch (error) {}
  };

  // 添加团队
  const _ADDTEAM = async (values) => {
    setLoading(true);
    try {
      const { code } = await addTeam(values);
      if (code === '10000') {
        message.success(t('addteam.message.success'));
        await _UPLOADTEAMID();
        navigate('/user', { replace: true, state: { from: '/addteam' } });
      }
      form.resetFields();
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };
  // 处理错误
  const handleFinshFailed = () => {
    message.error(t('addteam.message.validate_filed'));
  };
  // 处理提交
  const handleFinish = (values) => {
    _ADDTEAM(values);
  };
  return (
    <PageContent>
      <Spin spinning={loading}>
        <Form
          labelAlign="left"
          requiredMark={false}
          form={form}
          onFinish={handleFinish}
          onFinishFailed={handleFinshFailed}
        >
          <Form.Item
            name={'title'}
            rules={[
              { required: true, message: t('addteam.message.validate_name') },
            ]}
          >
            <Input
              placeholder={t('addteam.title')}
              className="add-team-input"
            />
          </Form.Item>
          <Form.Item
            name={'description'}
            rules={[
              {
                required: true,
                message: t('addteam.message.validate_description'),
              },
            ]}
          >
            <Input
              placeholder={t('addteam.description')}
              className="add-team-input"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                height: '42px',
                backgroundColor: '#18EAC4',
                color: '#0e0e0e',
                border: 'none',
              }}
            >
              {t('addteam.submit')}
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageContent>
  );
};

export default AddTeam;
